if (typeof wishlist === 'undefined') {
  class Wishlist {
    constructor() {
      this.name = 'uixthemes:wishlist';
    }

    getDefaults() {
      return {
        createdAt: Date.now(),
        items: [],
      };
    }

    getData() {
      let data = this.getDefaults();

      if (window.localStorage) {
        data = Object.assign({}, data, JSON.parse(localStorage.getItem(this.name)));
      }

      return data;
    }

    getItems() {
      return this.getData().items;
    }

    countItems() {
      return this.getItems().length;
    }

    addItem(itemId) {
      const data = this.getData();
      data.items.push(itemId);

      return this.update(data);
    }

    removeItem(itemId) {
      const data = this.getData();
      const index = data.items.indexOf(itemId);

      if (index < 0) {
        return false;
      }

      data.items.splice(index, 1);

      return this.update(data);
    }

    hasItem(itemId) {
      return this.getItems().includes(itemId);
    }

    update(data) {
      if (!window.localStorage) {
        return false;
      }

      data = Object.assign({}, this.getDefaults(), data);

      localStorage.setItem(this.name, JSON.stringify(data));

      document.dispatchEvent(new CustomEvent('wishlist_updated'));

      return true;
    }
  }

  var wishlist = new Wishlist();

  var updateWishlistCounters = () => {
    document.querySelectorAll('.wishlist-counter').forEach((el) => {
      el.innerText = wishlist.countItems();
    });
  };

  updateWishlistCounters();

  document.addEventListener('wishlist_updated', updateWishlistCounters);

  // Update all buttons.
  document.addEventListener('wishlist_updated', () => {
    document.querySelectorAll('wishlist-button').forEach((el) => {
      el.updateState(true);
    });
  });
}

if (!customElements.get('wishlist-button')) {
  customElements.define(
    'wishlist-button',
    class WishlistButton extends HTMLElement {
      constructor() {
        super();

        this.button = this.querySelector('button');
        this.itemId = this.button.dataset.handle;
        this.inWishlsit = false;

        this.updateState(true);

        this.button.addEventListener('click', this.toggle.bind(this));
      }

      updateState(force) {
        if (force) {
          this.inWishlsit = wishlist.hasItem(this.itemId);
        }

        if (this.inWishlsit) {
          this.button.classList.add('in-wishlist');
        } else {
          this.button.classList.remove('in-wishlist');
        }
      }

      toggle(event) {
        event.preventDefault();
        this.inWishlsit ? this.remove() : this.add();
      }

      add() {
        wishlist.addItem(this.itemId);

        this.inWishlsit = true;
        this.updateState();
      }

      remove() {
        wishlist.removeItem(this.itemId);

        this.inWishlsit = false;
        this.updateState();
      }
    }
  );
}

if (!customElements.get('wishlist-items')) {
  customElements.define(
    'wishlist-items',
    class WishlistItems extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          list: this.querySelector('.wishlist-items__list'),
          empty: this.querySelector('.wishlist-empty'),
        };

        this.render();
      }

      render() {
        if (wishlist.countItems()) {
          this.renderList();
        } else {
          this.renderEmpty();
        }
      }

      renderList() {
        const items = wishlist.getItems();

        Promise.all(
          items.map(async (item) => {
            const response = await fetch(window.Shopify.routes.root + 'products/' + item + '?section_id=wishlist-item');
            return await response.text();
          })
        ).then((texts) => {
          this.classList.remove('is-empty');
          this.elements.list.innerHTML = '';

          texts.map((text) => {
            const html = new DOMParser().parseFromString(text, 'text/html');

            this.elements.list.appendChild(html.querySelector('.shopify-section').firstChild);
          });
        });
      }

      renderEmpty() {
        this.classList.add('is-empty');
        this.elements.list.innerHTML = '';
        this.elements.empty.style.removeProperty('display');
      }
    }
  );
}

if (!customElements.get('wishlist-remove-button')) {
  customElements.define(
    'wishlist-remove-button',
    class WishlistRemoveButton extends HTMLElement {
      constructor() {
        super();

        this.button = this.querySelector('button');
        this.itemId = this.button.dataset.handle;

        this.button.addEventListener('click', this.removeItem.bind(this));
      }

      removeItem() {
        const wishlistElement = this.closest('wishlist-items');

        wishlist.removeItem(this.itemId);
        this.closest('.wishlist-item').remove();

        if (!wishlist.countItems() && wishlistElement) {
          wishlistElement.renderEmpty();
        }
      }
    }
  );
}
